import React from "react";


const Footer = ({ siteTitle }) => (
  <>
    <link
      href="https://fonts.googleapis.com/css2?family=Share+Tech+Mono|Montserrat:wght@300&family=Source+Code+Pro:wght@200&display=swap"
      rel="stylesheet"
      type="text/css"
    ></link>
  </>
);

export default Footer;
